import { fromJS } from 'immutable';
import { multiply, divide, add, isNil } from 'ramda';
import {
  roundDownToNearest,
  roundToNearest,
  roundUpToNearest,
} from '../../../utils/rounding-helpers';

const roundNumber = ({ roundType, cents }, num) => {
  const newNum = Number(num);
  if (roundType === 'alwaysUp') return roundUpToNearest(newNum, cents);
  if (roundType === 'alwaysDown') return roundDownToNearest(newNum, cents);
  return roundToNearest(newNum, cents);
};

const updateDiscountRates = ({ retailNettMeasure: measure, roundingSetting }, product) => {
  const discountDiff = product.get('discountDiff');
  return product
    .updateIn(['offers', 'discount'], discountOffers => !discountOffers ? discountOffers :
      discountOffers.map(offer => {
        const initialAmount = isNil(offer.get('initialAmount')) ? // Check isNil because offer may be 0
          (isNil(offer.get('amount')) ? 0 : offer.get('amount')) : // if no amount then 0 else amount
          offer.get('initialAmount');
        const amount = measure === 'percentage' ? multiply(initialAmount, divide(add(Number(discountDiff), 100), 100)) :
          add(Number(initialAmount), Number(discountDiff));
        return offer.get('notApplicable') ? offer : offer.merge(fromJS({
          initialAmount,
          amount: discountDiff ? roundNumber(roundingSetting, amount) : initialAmount,
        }));
      }));
};

export default updateDiscountRates;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/mass-rate-change/update-discount-rates.js